<app-box-section [title]="'carDetail.equipment.title' | translate">
  @if (equipment) {
    <app-tab-nav>
      @if (equipment.interior.items.length) {
        <app-tab-nav-item [value]="'car-detail-interior'">{{ 'carDetail.equipment.interior' | translate }}</app-tab-nav-item>
      }
      @if (equipment.exterior.items.length) {
        <app-tab-nav-item [value]="'car-detail-exterior'">{{ 'carDetail.equipment.exterior' | translate }}</app-tab-nav-item>
      }
      @if (equipment.technology.items.length) {
        <app-tab-nav-item [value]="'car-detail-technology'">{{ 'carDetail.equipment.technology' | translate }}</app-tab-nav-item>
      }
    </app-tab-nav>
    <app-tab-nav-swiper>
      @if (equipment.interior.items.length) {
        <app-car-detail-equipment-list [category]="equipment.interior" data-tab-id="car-detail-interior" [attr.data-tab-active]="active === 'interior'"></app-car-detail-equipment-list>
      }
      @if (equipment.exterior.items.length) {
        <app-car-detail-equipment-list [category]="equipment.exterior" data-tab-id="car-detail-exterior" [attr.data-tab-active]="active === 'exterior'"></app-car-detail-equipment-list>
      }
      @if (equipment.technology.items.length) {
        <app-car-detail-equipment-list [category]="equipment.technology" data-tab-id="car-detail-technology" [attr.data-tab-active]="active === 'technology'"></app-car-detail-equipment-list>
      }
    </app-tab-nav-swiper>
  }
</app-box-section>
